import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useMedia } from '@ts/utils/useMedia';

function ShareThis({ match }) {
    const isMobile = useMedia('(max-width: 1024px)');
    useEffect(() => {
        const isSharePage =
            match.url.search('blog/') !== -1 || match.url.search('traveler-stories/') !== -1;

        if (typeof document !== 'undefined') {
            const STscript = document.getElementById('sharethis');
            const shareButtonsContainer = document.getElementById('st-2');

            if (STscript === null && isSharePage) {
                const shareScript = document.createElement('script');
                shareScript.setAttribute('async', true);
                shareScript.setAttribute(
                    'src',
                    'https://platform-api.sharethis.com/js/sharethis.js#property=5cc218cc36d0970012b884fd&product=sticky-share-buttons'
                );
                shareScript.setAttribute('id', 'sharethis');
                document.head.appendChild(shareScript);
            }
            if (STscript !== null && isSharePage && shareButtonsContainer) {
                if (isMobile) {
                    shareButtonsContainer.style.display = 'flex';
                } else {
                    shareButtonsContainer.style.display = 'block';
                }
            }
            if (STscript !== null && !isSharePage && shareButtonsContainer) {
                shareButtonsContainer.style.display = 'none';
            }
        }
    }, [match, isMobile]);
    return null;
}

export default withRouter(ShareThis);
